// extracted by mini-css-extract-plugin
export default {"icons":"icons_icons__KtQV0","iconContainer":"icons_iconContainer__dnBqp"};